module.exports = __webpack_public_path__ + "media/images/responsive/top/flow_step02-c766c13af82b2fc7cf4bb83edf1a95a1.jpg";